export default __webpack_public_path__ + "static/media/bnr11.e1a6a954.jpg";